import React from "react"

const UsersIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.7923 9.52221C21.5824 10.3122 21.5824 11.5931 20.7923 12.3832C20.0023 13.1732 18.7214 13.1732 17.9314 12.3832C17.1414 11.5931 17.1414 10.3122 17.9314 9.52221C18.7214 8.73218 20.0023 8.73218 20.7923 9.52221"
      stroke="#00A9E0"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2024 5.91236C15.4189 7.12884 15.4189 9.10115 14.2024 10.3176C12.9859 11.5341 11.0136 11.5341 9.79713 10.3176C8.58065 9.10116 8.58065 7.12885 9.79713 5.91236C11.0136 4.69588 12.9859 4.69588 14.2024 5.91236"
      stroke="#00A9E0"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.06871 9.52221C6.85874 10.3122 6.85874 11.5931 6.06871 12.3832C5.27868 13.1732 3.99779 13.1732 3.20776 12.3832C2.41773 11.5931 2.41773 10.3122 3.20776 9.52221C3.99779 8.73218 5.27868 8.73218 6.06871 9.52221"
      stroke="#00A9E0"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.0002 18.9983V17.9023C23.0002 16.5213 21.8812 15.4023 20.5002 15.4023H19.6992"
      stroke="#00A9E0"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 18.9983V17.9023C1 16.5213 2.119 15.4023 3.5 15.4023H4.301"
      stroke="#00A9E0"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3392 18.9994V17.3984C17.3392 15.4654 15.7722 13.8984 13.8392 13.8984H10.1602C8.22716 13.8984 6.66016 15.4654 6.66016 17.3984V18.9994"
      stroke="#00A9E0"
      strokeWidth="1.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default UsersIcon
